/**
 * Aviso de mensagem nova do WhatsApp, por casa. [Bruno 2026-10-13]
 *
 * "Chegou mensagem no WhatsApp do Meu Contador, avisar que o Meu Contador tem
 * uma nova mensagem; da NivelOn a mesma coisa." Usado pelo cockpit
 * (components/AvisoWhatsapp) e pela tela do celular (/atendimento).
 *
 * Preferência por pessoa e por casa, guardada no navegador: quem só atende a
 * NivelOn desliga o Meu Contador e não ouve nada dele.
 */
export const CASAS_AVISO = {
  meu_contador: { nome: 'Meu Contador', cor: '#2F5CA6', slug: 'meu-contador' },
  nivelon: { nome: 'NivelOn', cor: '#1e7f4f', slug: 'nivelon' },
};

const CHAVE = 'wa_avisos';

export function lerAvisos() {
  try {
    const p = JSON.parse(localStorage.getItem(CHAVE) || '{}') || {};
    return { meu_contador: p.meu_contador !== false, nivelon: p.nivelon !== false, som: p.som !== false };
  } catch (_) { return { meu_contador: true, nivelon: true, som: true }; }
}

export function gravarAvisos(p) {
  try { localStorage.setItem(CHAVE, JSON.stringify(p)); } catch (_) { /* aba anônima: vale só agora */ }
  try { window.dispatchEvent(new CustomEvent('wa-avisos-mudou', { detail: p })); } catch (_) { /* ok */ }
}

/** Dois toques curtos; tom diferente por casa, pra saber de ouvido de onde veio. */
export function tocarAviso(casa) {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const [f1, f2] = casa === 'nivelon' ? [660, 990] : [523, 784];
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = 'sine';
    o.frequency.setValueAtTime(f1, ctx.currentTime);
    o.frequency.setValueAtTime(f2, ctx.currentTime + 0.12);
    g.gain.setValueAtTime(0.0001, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.16, ctx.currentTime + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.4);
    o.connect(g); g.connect(ctx.destination);
    o.start(); o.stop(ctx.currentTime + 0.42);
    setTimeout(() => { try { ctx.close(); } catch (_) { /* ok */ } }, 700);
  } catch (_) { /* sem som, sem problema */ }
  try { if (navigator.vibrate) navigator.vibrate([120, 60, 120]); } catch (_) { /* ok */ }
}

export function textoDoAviso(n) {
  const quem = n.nome || 'um contato';
  const corpo = n.tipo === 'imagem' ? '📷 Imagem' : n.tipo === 'audio' ? '🎤 Áudio'
    : n.tipo === 'documento' ? '📎 Documento' : n.tipo === 'video' ? '🎬 Vídeo' : 'Mandou uma mensagem';
  return { titulo: `${CASAS_AVISO[n.casa]?.nome || 'WhatsApp'} · nova mensagem`, quem, corpo };
}

/** Notificação do sistema (só quando a pessoa permitiu e a tela não está à vista). */
export function notificarSistema(n, aoClicar) {
  if (typeof window.Notification === 'undefined' || window.Notification.permission !== 'granted') return;
  if (document.visibilityState === 'visible') return;
  const t = textoDoAviso(n);
  try {
    const x = new window.Notification(t.titulo, { body: `${t.quem}: ${t.corpo}`, tag: `wa-${n.conversa_id}`, icon: '/logos/marcal-simbolo-colorido.svg' });
    x.onclick = () => { window.focus(); if (aoClicar) aoClicar(); x.close(); };
  } catch (_) { /* navegador sem suporte (ex.: Safari fora da tela inicial) */ }
}

export async function pedirPermissao() {
  if (typeof window.Notification === 'undefined') return 'unsupported';
  try { return await window.Notification.requestPermission(); } catch (_) { return window.Notification.permission; }
}
